import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import {
  loadPlanEntries,
  changeOrder,
  setInitialFilters,
  clearPlanEntries,
  setDefaultFilter,
  clearAllFilters,
  changeFilterUrl
} from '../../../redux/actions/planEntries'
import PropTypes from 'prop-types'
import { planEntries as planEntriesSelector } from '../../../redux/selectors/planEntries'
import ClassFinderContent from './ClassFinderContent'
import {
  convertFilterByFieldToObject,
  createFilteredStylesObj
} from './classFinderHelperMethods'
import { insertPlanCategories } from '../../../redux/actions/planCategories'
import { useCommonEntryContext } from 'components_v2/common'
import { useSearchParams } from 'react-router-dom'

const ClassFinderDataLoader = ({
  autopaginate,
  baseUrl,
  defaultOrder = 'relevance',
  defaultValue,
  dropdownOptions,
  includeFilters,
  preloadedFilters,
  withSubcategories,
  // Redux state
  planEntries,
  // Redux dispatch
  loadPlanEntries,
  setInitialFilters,
  changeOrder,
  insertPlanCategories,
  clearPlanEntries,
  setDefaultFilter,
  changeFilterUrl,
  clearAllFilters
}) => {
  // componentDidMount + componentWillUnmount
  const { searchParams } = useCommonEntryContext()
  const isNav = searchParams?.get('from') === 'nav'
  const [, setSearchParams] = useSearchParams()
  const [loaded, setLoaded] = useState(false)
  const [currentParams, setCurrentParam] = useState('')

  const loadAllData = () => {
    if (defaultValue) {
      setDefaultFilter({
        instructors: preloadedFilters.instructors || []
      })
    }

    const stylesFilterObj = createFilteredStylesObj(
      dropdownOptions.styles,
      preloadedFilters.styles
    )

    const individualStylesObj = {}
    for (const individualFilter in stylesFilterObj) {
      individualStylesObj[individualFilter] =
        stylesFilterObj[individualFilter].filteredSubcategories
    }

    const preFilters = {
      duration: preloadedFilters.duration,
      instructors: convertFilterByFieldToObject(
        dropdownOptions.instructors || [],
        'slug',
        preloadedFilters.instructors
      ),
      difficulties: preloadedFilters.difficulties,
      intensities: convertFilterByFieldToObject(
        dropdownOptions.intensities,
        'level',
        preloadedFilters.intensities
      ),
      equipment: preloadedFilters.equipment || [],
      focus_area: preloadedFilters.focus_area || [],
      excludeCompleted: preloadedFilters.excludeCompleted || null,
      styles: preloadedFilters.styles || [],
      ...individualStylesObj
    }

    insertPlanCategories(dropdownOptions.styles)
    setInitialFilters(preFilters)
    changeOrder(defaultOrder)
    clearPlanEntries()
    loadPlanEntries(() => {})
  }

  useEffect(() => {
    loadAllData()
    setLoaded(true)
    return () => {
      clearAllFilters()
      setDefaultFilter({})
      changeFilterUrl({})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!isNav) return
    const params = new URLSearchParams(searchParams)
    params.delete('from')
    setSearchParams(params)
    if (loaded && currentParams !== params?.toString()) {
      setCurrentParam(params.toString())
      loadAllData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isNav, searchParams, currentParams])

  return (
    <ClassFinderContent
      withSubcategories={withSubcategories}
      autopaginate={autopaginate}
      includeFilters={includeFilters}
      planEntries={planEntries}
      preloadedFilters={preloadedFilters}
      baseUrl={baseUrl}
      dropdownOptions={dropdownOptions}
    />
  )
}

const mapStateToProps = (state) => {
  return {
    planEntries: planEntriesSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadPlanEntries: (callback) => dispatch(loadPlanEntries(callback)),
  setInitialFilters: (filters) => dispatch(setInitialFilters(filters)),
  changeOrder: (order) => dispatch(changeOrder(order)),
  changeFilterUrl: (order) => dispatch(changeFilterUrl(order)),
  insertPlanCategories: (categories) =>
    dispatch(insertPlanCategories(categories)),
  clearPlanEntries: () => dispatch(clearPlanEntries()),
  setDefaultFilter: (value) => dispatch(setDefaultFilter(value)),
  clearAllFilters: () => dispatch(clearAllFilters())
})

ClassFinderDataLoader.propTypes = {
  autopaginate: PropTypes.bool,
  baseUrl: PropTypes.string,
  defaultOrder: PropTypes.string,
  defaultValue: PropTypes.any,
  dropdownOptions: PropTypes.object,
  includeFilters: PropTypes.bool,
  preloadedFilters: PropTypes.object,
  withSubcategories: PropTypes.bool,
  // Redux state
  planEntries: PropTypes.array,
  filteredAttributes: PropTypes.object,
  // Redux dispatch
  loadPlanEntries: PropTypes.func,
  setInitialFilters: PropTypes.func,
  changeOrder: PropTypes.func,
  insertPlanCategories: PropTypes.func,
  clearPlanEntries: PropTypes.func,
  setDefaultFilter: PropTypes.func,
  clearAllFilters: PropTypes.func
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClassFinderDataLoader)
